import * as types from '../../constants';
import { assignTabDataAndDispatch } from 'state/tabs/actions';

export function setTabColor(index, tabColorPalette) {
  return assignTabDataAndDispatch(
    { type: types.SET_COLOR, tabData: { tabColorPalette } },
    index
  );
}
